(function () {
  function initToolbar(root) {
    if (!root || root.dataset.tgToolbarInit === '1') return;
    root.dataset.tgToolbarInit = '1';

    var menus = root.querySelectorAll('[data-tg-menu]');

    menus.forEach(function (menu) {
      var trigger = menu.querySelector('[data-tg-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var isOpen = menu.classList.contains('is-open');
        // close other open menus
        menus.forEach(function (m) {
          if (m !== menu) {
            m.classList.remove('is-open');
            var t = m.querySelector('[data-tg-trigger]');
            if (t) t.setAttribute('aria-expanded', 'false');
          }
        });
        menu.classList.toggle('is-open', !isOpen);
        trigger.setAttribute('aria-expanded', String(!isOpen));
      });
    });

    document.addEventListener('click', function (e) {
      menus.forEach(function (menu) {
        if (!menu.contains(e.target)) {
          menu.classList.remove('is-open');
          var t = menu.querySelector('[data-tg-trigger]');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        menus.forEach(function (menu) {
          menu.classList.remove('is-open');
          var t = menu.querySelector('[data-tg-trigger]');
          if (t) t.setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-tg-toolbar]').forEach(initToolbar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-tg-toolbar]');
    if (root) initToolbar(root);
  });
})();
